import {
  convertToStringDate,
  SumDays,
  convertToStringTime,
  convertDateFormat,
} from '../../../../../components/genericFunction/timeHelper';
import { addDate, getHourAndMinute } from '../../../../../scripts/moment';
import { copyObject } from '../../../../../scripts/itineraryBuilder/guest';
import {
  setDateArrival,
  setDateSummaryProgram,
  setDateDeparture,
} from '../../../../../scripts/itineraryBuilder/dailyProgram';
const fixDateDailyProgram = (date, dailyProgram) => {
  let newDp = dailyProgram.map((daily, i) => {
    let newDate = convertToStringDate(SumDays(date, i));
    daily.Date = `${newDate}T00:00:00`;
    daily.Movements.map(move => {
      move.DateTime = `${newDate}${convertToStringTime(move.DateTime)}`;
      return move;
    });
    return daily;
  });
  return newDp;
};

const fixDateHeadlineProgram = (date, headlineProgram) => {
  let setHourAndMinuteDeparture = getHourAndMinute(
    headlineProgram.Departures[0].Date
  );
  let setHourAndMinuteReturns = getHourAndMinute(
    headlineProgram.Returns[0].Date
  );
  let totalDay = headlineProgram.MainPrograms.reduce((result, current) => {
    result = result + current.TotalDays;
    return result;
  }, 0);
  let endDate = addDate(date, totalDay - 1, 'd');
  headlineProgram.Departures[0].Date = `${convertDateFormat(
    date,
    'YYYY-MM-DD'
  )}T${setHourAndMinuteDeparture}:00`;
  headlineProgram.Returns[0].Date = `${convertDateFormat(
    endDate,
    'YYYY-MM-DD'
  )}T${setHourAndMinuteReturns}:00`;

  headlineProgram.MainPrograms.map(item => {
    // let lastDate = date;
    let lastDate = `${convertDateFormat(date, 'YYYY-MM-DD')}T${getHourAndMinute(
      item.Date
    )}:00`;
    item.Date = lastDate;
    // item.LeavingDate = addDate(lastDate, item.TotalDays - 1, 'd');
    item.LeavingDate = `${convertDateFormat(
      addDate(lastDate, item.TotalDays - 1, 'd'),
      'YYYY-MM-DD'
    )}T${getHourAndMinute(item.LeavingDate)}:00`;
    let setHourAndMinuteCheckIn = getHourAndMinute(
      item.AccommodationSummary.CheckIn
    );
    let setHourAndMinuteCheckOut = getHourAndMinute(
      item.AccommodationSummary.CheckOut
    );
    item.AccommodationSummary.DateTime = lastDate;
    item.AccommodationSummary.CheckIn = `${convertDateFormat(
      lastDate,
      'YYYY-MM-DD'
    )}T${
      setHourAndMinuteCheckIn
        ? setHourAndMinuteCheckIn
        : getHourAndMinute(item.LeavingDate)
    }:00`;
    item.AccommodationSummary.CheckOut = `${convertDateFormat(
      addDate(date, item.TotalDays - 1, 'd'),
      'YYYY-MM-DD'
    )}T${
      setHourAndMinuteCheckOut
        ? setHourAndMinuteCheckOut
        : getHourAndMinute(item.LeavingDate)
    }:00`;
    lastDate = addDate(date, item.TotalDays - 1, 'd');
    return item;
  });
  return headlineProgram;
};

const setHeadlineFixedPrice = (date, headlineProgram) => {
  let headLineProg = copyObject(headlineProgram);
  let setHourAndMinuteDeparture = getHourAndMinute(
    headlineProgram.Departures[0].Date
  );
  let newDate = `${convertDateFormat(
    date,
    'YYYY-MM-DD'
  )}T${setHourAndMinuteDeparture}:00`;
  let newArrival = setDateArrival(headlineProgram.Departures[0], newDate);
  let newMainProg = setDateSummaryProgram(
    newArrival,
    headLineProg.MainPrograms
  );
  let newDeparture = setDateDeparture(headLineProg.Returns[0], newMainProg);
  headLineProg.Departures[0] = newArrival;
  headLineProg.MainPrograms = newMainProg;
  headLineProg.Returns[0] = newDeparture;
  return headLineProg;
};

export { fixDateDailyProgram, fixDateHeadlineProgram, setHeadlineFixedPrice };
